var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_38448)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7506 27.8927C23.3851 27.8432 22.5776 27.8266 20.9795 28.1486C20.7902 28.1923 20.5959 28.2117 20.4015 28.2064C20.1905 28.183 19.9826 28.1387 19.7809 28.0743C18.9054 27.7854 18.1828 27.8762 17.7578 28.0908C17.5074 28.2225 17.292 28.409 17.1288 28.6356C16.8653 28.9824 16.3127 30.039 15.5562 30.3197C15.1312 30.5838 14.6721 30.8563 14.2726 31.2443C14.0176 31.5002 13.9496 32.1028 13.2781 32.6889C12.6181 33.6332 11.775 34.4435 10.7959 35.0746C9.52935 35.9332 8.4668 36.1973 8.4668 36.1973C8.4668 36.1973 11.2804 36.9485 14.3661 35.5452C16.7122 34.472 17.9278 32.3835 18.2083 31.9212L19.7384 29.3951C19.8744 29.164 20.1209 28.8668 20.3504 28.7512C20.4269 28.7099 20.4949 28.6852 20.512 28.6686C20.682 28.5861 20.8605 28.5201 21.039 28.454C22.11 28.0826 23.2236 28.0495 23.7421 27.9917C23.8101 27.9752 23.8016 27.9009 23.7506 27.8927Z",
    fill: "url(#paint0_linear_1322_38448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7495 27.8925C23.384 27.843 22.5764 27.8264 20.9783 28.1484C20.7891 28.1921 20.5948 28.2115 20.4003 28.2062C20.1894 28.1828 19.9814 28.1386 19.7798 28.0741C18.8787 27.7852 18.1902 27.8595 17.7567 28.0906C17.5062 28.2223 17.2909 28.4088 17.1276 28.6354C16.8641 28.9822 16.3116 30.0388 15.555 30.3195C14.705 29.5435 13.957 28.8914 13.2344 28.3135C12.8264 27.9998 12.4269 27.7026 12.0868 27.488C11.2557 26.9218 10.3803 26.4195 9.4687 25.9856C9.07768 25.8122 8.66966 25.6553 8.21914 25.4902C8.02362 25.4325 7.91312 25.5233 7.87912 25.6719C7.86211 25.7214 7.84511 25.8535 7.93012 26.0846C8.16149 26.6691 8.44004 27.235 8.76316 27.7769C8.89067 27.9998 9.03518 28.231 9.18819 28.4621C9.90041 29.5508 10.7358 30.5587 11.6788 31.4669C11.8743 31.6486 12.0613 31.8137 12.2654 31.9705C12.5094 32.1687 12.7649 32.3534 13.0304 32.5236C13.0559 32.5401 13.1834 32.6144 13.2684 32.6639C13.4384 32.7547 13.6679 32.8621 13.8125 32.9198C14.4016 33.182 15.0431 33.3145 15.691 33.3078C16.6346 33.3326 17.3996 33.0437 17.7737 32.5566C17.9309 32.3503 18.0756 32.1353 18.2072 31.9127L19.7373 29.3867C19.8733 29.1555 20.1198 28.8583 20.3493 28.7428C20.4258 28.7015 20.4938 28.6767 20.5108 28.6602C20.6723 28.5859 20.6723 28.6107 20.8423 28.5446C21.9304 28.1732 23.231 28.0411 23.7495 27.9833C23.7609 27.982 23.7715 27.9766 23.7791 27.9682C23.7867 27.9599 23.7909 27.9491 23.7909 27.9379C23.7909 27.9267 23.7867 27.9159 23.7791 27.9076C23.7715 27.8992 23.7609 27.8938 23.7495 27.8925Z",
    fill: "url(#paint1_linear_1322_38448)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M7.86328 25.7614C7.86328 25.7366 7.87178 25.7118 7.86328 25.6953C7.87185 25.7165 7.87185 25.7401 7.86328 25.7614Z",
    fill: "url(#paint2_linear_1322_38448)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M8.57766 25.6043C8.56461 25.5976 8.54985 25.5947 8.53516 25.596C8.56066 25.6043 8.58616 25.6208 8.61166 25.629C8.61166 25.6208 8.59466 25.6125 8.57766 25.6043Z",
    fill: "url(#paint3_linear_1322_38448)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M8.84064 25.7133C8.83214 25.7133 8.81514 25.7051 8.80664 25.7051C8.82836 25.7156 8.85115 25.7239 8.87464 25.7298C8.85764 25.7216 8.84914 25.7133 8.84064 25.7133Z",
    fill: "url(#paint4_linear_1322_38448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8301 30.4666C14.4077 30.551 14.9979 30.4943 15.5472 30.3015C15.0372 29.8392 14.5527 29.4182 14.1021 29.0385C13.8726 28.8486 13.6516 28.6587 13.4391 28.4854C13.4306 28.4771 13.4136 28.4689 13.4136 28.4606C13.3541 28.4111 13.3031 28.3698 13.2521 28.3285C13.2351 28.3203 13.2266 28.3038 13.2181 28.3038C12.8101 27.9901 12.4106 27.7012 12.0875 27.4782C11.2205 26.9086 10.3534 26.3803 9.47789 25.9758C9.40139 25.9346 9.32488 25.9098 9.23988 25.8685C9.21816 25.858 9.19537 25.8497 9.17188 25.8438C12.5551 27.6186 13.6346 29.2283 13.8301 30.4666Z",
    fill: "url(#paint5_linear_1322_38448)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M7.98988 26.2413C7.96438 26.1917 7.94738 26.134 7.92188 26.0762C7.94738 26.1257 7.96438 26.1835 7.98988 26.2413Z",
    fill: "url(#paint6_linear_1322_38448)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.86328 25.7865C7.86328 25.778 7.86328 25.778 7.87203 25.7695C7.87203 25.778 7.87203 25.778 7.86328 25.7865Z",
    fill: "url(#paint7_linear_1322_38448)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.22852 25.4805C8.33902 25.5217 8.44103 25.5548 8.54303 25.596C8.43253 25.5548 8.33052 25.5135 8.22852 25.4805Z",
    fill: "url(#paint8_linear_1322_38448)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.12152 25.8276L9.17252 25.8523C9.07901 25.8111 8.97701 25.7698 8.875 25.7285C8.909 25.745 8.9345 25.7533 8.96851 25.7698C9.02088 25.7854 9.07201 25.8048 9.12152 25.8276Z",
    fill: "url(#paint9_linear_1322_38448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1238 28.7329C9.2143 28.0229 8.35576 27.0323 7.99023 26.248C8.84028 28.3366 11.0504 31.3002 13.0225 32.522C13.0565 32.5467 13.1755 32.6128 13.269 32.6623C13.524 32.2826 13.9916 31.4983 13.8301 30.4664C12.6145 30.3096 11.3054 29.6657 10.1238 28.7329Z",
    fill: "url(#paint10_linear_1322_38448)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.80546 25.7052L8.62695 25.6309C8.63545 25.6309 8.64395 25.6391 8.65245 25.6391C8.69496 25.6556 8.74596 25.6804 8.80546 25.7052Z",
    fill: "url(#paint11_linear_1322_38448)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M10.1237 28.7331C11.3053 29.6659 12.6144 30.3015 13.8299 30.4584C13.6344 29.2284 12.5548 27.6104 9.17167 25.852C9.15385 25.8455 9.13676 25.8372 9.12066 25.8273C9.06966 25.8025 9.01866 25.786 8.97615 25.7612C8.94215 25.7447 8.91665 25.7365 8.88265 25.72C8.86093 25.7094 8.83814 25.7011 8.81465 25.6952C8.76282 25.671 8.70874 25.6516 8.65314 25.6374C8.64464 25.6374 8.63614 25.6291 8.62764 25.6291C8.60214 25.6209 8.57663 25.6044 8.55113 25.5961C8.44913 25.5631 8.34712 25.5136 8.23662 25.4806C8.0411 25.4228 7.9306 25.5136 7.8881 25.6539C7.8838 25.6702 7.88096 25.6867 7.8796 25.7034C7.87109 25.72 7.8796 25.7447 7.8796 25.7695C7.8796 25.7777 7.8796 25.7777 7.87109 25.786C7.87569 25.8847 7.89576 25.9821 7.9306 26.0749C7.94953 26.134 7.97224 26.1919 7.9986 26.2483C8.35562 27.0325 9.22267 28.0231 10.1237 28.7331Z",
    fill: "url(#paint12_linear_1322_38448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1237 28.7331C11.3053 29.6659 12.6144 30.3015 13.8299 30.4584C13.6344 29.2284 12.5548 27.6104 9.17167 25.852C9.15385 25.8455 9.13676 25.8372 9.12066 25.8273C9.06966 25.8025 9.01866 25.786 8.97615 25.7612C8.94215 25.7447 8.91665 25.7365 8.88265 25.72C8.86093 25.7094 8.83814 25.7011 8.81465 25.6952C8.76282 25.671 8.70874 25.6516 8.65314 25.6374C8.64464 25.6374 8.63614 25.6291 8.62764 25.6291C8.60214 25.6209 8.57663 25.6044 8.55113 25.5961C8.44913 25.5631 8.34712 25.5136 8.23662 25.4806C8.0411 25.4228 7.9306 25.5136 7.8881 25.6539C7.8838 25.6702 7.88096 25.6867 7.8796 25.7034C7.87109 25.72 7.8796 25.7447 7.8796 25.7695C7.8796 25.7777 7.8796 25.7777 7.87109 25.786C7.87569 25.8847 7.89576 25.9821 7.9306 26.0749C7.94953 26.134 7.97224 26.1919 7.9986 26.2483C8.35562 27.0325 9.22267 28.0231 10.1237 28.7331Z",
    fill: "url(#paint13_linear_1322_38448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7504 27.8927C23.3849 27.8432 22.5773 27.8266 20.9792 28.1486C20.79 28.1923 20.5957 28.2117 20.4012 28.2064C20.1903 28.183 19.9824 28.1387 19.7807 28.0743C19.367 27.9294 18.928 27.8649 18.4886 27.8844C18.1876 27.9047 17.8974 28.0015 17.6471 28.1651C17.4468 28.2912 17.2736 28.4538 17.137 28.6439C16.8735 28.9906 16.321 30.0473 15.5645 30.3279C16.1595 30.8728 17.0775 31.3268 17.9361 31.0544C18.7606 30.7902 19.2706 30.0803 19.4322 29.8491C19.597 29.6062 19.7788 29.3745 19.9762 29.1557C20.2548 28.8723 20.6028 28.6622 20.9877 28.5448C21.9568 28.2311 23.4189 28.0413 23.7674 28.0082C23.8099 27.9752 23.8014 27.9009 23.7504 27.8927Z",
    fill: "url(#paint14_linear_1322_38448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9953 29.0402C19.1361 29.0402 19.2503 28.9294 19.2503 28.7926C19.2503 28.6558 19.1361 28.5449 18.9953 28.5449C18.8544 28.5449 18.7402 28.6558 18.7402 28.7926C18.7402 28.9294 18.8544 29.0402 18.9953 29.0402Z",
    fill: "#595F69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.441 32.1289C32.9339 32.1296 32.4479 32.3256 32.0894 32.6737C31.7308 33.0219 31.5291 33.4939 31.5283 33.9863V34.5394C31.5291 35.0318 31.7308 35.5038 32.0894 35.852C32.4479 36.2001 32.9339 36.3961 33.441 36.3968H34.6565V35.7199H33.441C33.1303 35.7194 32.8316 35.6038 32.6057 35.3967C32.3798 35.1896 32.2438 34.9066 32.2254 34.6055H34.716C34.7987 34.6056 34.8805 34.5899 34.957 34.5593C35.0333 34.5287 35.1028 34.4837 35.1612 34.4269C35.2197 34.3702 35.266 34.3027 35.2975 34.2285C35.3291 34.1543 35.3452 34.0748 35.3451 33.9945C35.3465 33.7506 35.2984 33.5087 35.2034 33.2828C35.1084 33.0569 34.9685 32.8514 34.7916 32.678C34.6147 32.5048 34.4044 32.367 34.1726 32.2728C33.9408 32.1786 33.6922 32.1297 33.441 32.1289ZM32.2254 33.9203C32.2433 33.6189 32.3791 33.3356 32.6051 33.1284C32.8311 32.9212 33.1301 32.8058 33.441 32.8058C33.7517 32.8058 34.0508 32.9212 34.2768 33.1284C34.5028 33.3356 34.6387 33.6189 34.6565 33.9203H32.2254Z",
    fill: "#595F69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2063 31.4523H23.7164V30.7754H23.2063C23.0139 30.776 22.8237 30.8143 22.6469 30.8881C22.4702 30.9618 22.3106 31.0695 22.1778 31.2047C21.9091 31.4755 21.7571 31.8358 21.7527 32.2118V32.2943H21.3447V32.9713H21.7527V36.3806H22.4498V32.9713H23.3848V32.3026H22.4498V32.2201C22.4583 31.8073 22.8068 31.4523 23.2063 31.4523Z",
    fill: "#595F69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5017 30.7832H24.8047V36.3967H25.5017V30.7832Z",
    fill: "#595F69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6902 32.1289H47.9932V36.3803H48.6902V32.1289Z",
    fill: "#30B99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6993 34.655C29.6993 34.9374 29.5838 35.2083 29.3781 35.408C29.1725 35.6077 28.8936 35.7199 28.6028 35.7199C28.3119 35.7199 28.033 35.6077 27.8274 35.408C27.6217 35.2083 27.5062 34.9374 27.5062 34.655V32.1289H26.8262V34.655C26.8262 35.1147 27.0142 35.5557 27.349 35.8808C27.6838 36.2059 28.1378 36.3885 28.6113 36.3885C29.0847 36.3885 29.5388 36.2059 29.8735 35.8808C30.2083 35.5557 30.3964 35.1147 30.3964 34.655V32.1289H29.6993V34.655Z",
    fill: "#595F69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.827 32.1289C37.3541 32.1303 36.9009 32.3133 36.5663 32.6381C36.2319 32.963 36.0434 33.4031 36.042 33.8625V36.3885H36.7391V33.8625C36.7391 33.58 36.8546 33.3092 37.0603 33.1095C37.2659 32.9098 37.5449 32.7976 37.8355 32.7976C38.1265 32.7976 38.4054 32.9098 38.6111 33.1095C38.8168 33.3092 38.9322 33.58 38.9322 33.8625V36.3885H39.6292V33.8625C39.621 33.4023 39.4282 32.9634 39.0913 32.6396C38.7546 32.3157 38.3011 32.1324 37.827 32.1289Z",
    fill: "#595F69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6089 34.952V32.8057H42.5441V32.137H41.6089V30.7832H40.9204V32.137H40.3086V32.814H40.9204V34.9603C40.9215 35.3321 41.0742 35.6885 41.3449 35.9514C41.6156 36.2144 41.9828 36.3626 42.3657 36.3637H42.6716V35.6867H42.3657C42.165 35.6863 41.9728 35.6088 41.831 35.4711C41.6895 35.3334 41.6095 35.1468 41.6089 34.952Z",
    fill: "#595F69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9263 34.952V32.8057H51.8612V32.137H50.9263V30.7832H50.2293V32.137H49.6172V32.814H50.2293V34.9603C50.2304 35.3321 50.3831 35.6885 50.6538 35.9514C50.9245 36.2144 51.2914 36.3626 51.6743 36.3637H51.9805V35.6867H51.6743C51.4751 35.6846 51.2849 35.6062 51.1449 35.4687C51.0048 35.3311 50.9263 35.1455 50.9263 34.952Z",
    fill: "#30B99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1338 30.7832V32.5085C44.4462 32.2697 44.8329 32.1416 45.2305 32.1453C45.7034 32.1466 46.1567 32.3297 46.4913 32.6545C46.8256 32.9794 47.0143 33.4195 47.0154 33.8789V34.6631C47.0154 35.1229 46.8273 35.5638 46.4927 35.8889C46.1578 36.214 45.704 36.3967 45.2305 36.3967C44.757 36.3967 44.3029 36.214 43.9683 35.8889C43.6334 35.5638 43.4453 35.1229 43.4453 34.6631V30.7832H44.1338ZM44.1338 34.2421V34.6548C44.1338 34.9373 44.2493 35.2081 44.455 35.4079C44.6606 35.6075 44.9396 35.7197 45.2305 35.7197C45.5212 35.7197 45.8001 35.6075 46.0058 35.4079C46.2115 35.2081 46.3269 34.9373 46.3269 34.6548V33.8706C46.3269 33.5882 46.2115 33.3173 46.0058 33.1176C45.8001 32.9179 45.5212 32.8057 45.2305 32.8057C44.9396 32.8057 44.6606 32.9179 44.455 33.1176C44.2493 33.3173 44.1338 33.5882 44.1338 33.8706V34.2421Z",
    fill: "#30B99E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1322_38448",
    x1: 24.0795,
    y1: 31.408,
    x2: 8.17854,
    y2: 32.7299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2986,
    stopColor: "#0097CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#0999C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5119,
    stopColor: "#229DAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6469,
    stopColor: "#42A38F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#5DAD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9239,
    stopColor: "#A1C661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BED153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1322_38448",
    x1: 7.39166,
    y1: 27.3905,
    x2: 22.7182,
    y2: 31.7329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08199,
    stopColor: "#3D65AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2305,
    stopColor: "#2372B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5058,
    stopColor: "#00B8BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1322_38448",
    x1: 7.85708,
    y1: 25.7267,
    x2: 16.1826,
    y2: 28.0856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1297
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3277,
    stopColor: "#00334B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5276,
    stopColor: "#006190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6723,
    stopColor: "#007FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7457,
    stopColor: "#008ACC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1322_38448",
    x1: 9.95901,
    y1: 40.6842,
    x2: 17.7632,
    y2: 40.6842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1297
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3277,
    stopColor: "#00334B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5276,
    stopColor: "#006190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6723,
    stopColor: "#007FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7457,
    stopColor: "#008ACC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1322_38448",
    x1: 10.0723,
    y1: 36.9304,
    x2: 17.0094,
    y2: 36.9304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1297
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3277,
    stopColor: "#00334B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5276,
    stopColor: "#006190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6723,
    stopColor: "#007FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7457,
    stopColor: "#008ACC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1322_38448",
    x1: 8.72715,
    y1: 27.4134,
    x2: 15.7979,
    y2: 29.4167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1297,
    stopColor: "#2483C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1672,
    stopColor: "#2486C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#29B1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9352,
    stopColor: "#2BC2E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1322_38448",
    x1: 9.18751,
    y1: 102.219,
    x2: 16.1246,
    y2: 102.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1297
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3277,
    stopColor: "#00334B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5276,
    stopColor: "#006190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6723,
    stopColor: "#007FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7457,
    stopColor: "#008ACC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1322_38448",
    x1: 7.86867,
    y1: 25.7783,
    x2: 7.86867,
    y2: 25.7783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682C90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#817CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1322_38448",
    x1: 41.371,
    y1: 77.7902,
    x2: 25.1202,
    y2: 77.7902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682C90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#817CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1322_38448",
    x1: 40.2261,
    y1: 81.8923,
    x2: 24.8536,
    y2: 81.8923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682C90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#817CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1322_38448",
    x1: 7.33128,
    y1: 28.5738,
    x2: 14.0851,
    y2: 30.4874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1297,
    stopColor: "#3B67AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5697,
    stopColor: "#227CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9352,
    stopColor: "#118AA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1322_38448",
    x1: 27.4376,
    y1: 59.2924,
    x2: 18.2141,
    y2: 59.2924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682C90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#817CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1322_38448",
    x1: 118.747,
    y1: 2388.45,
    x2: 726.61,
    y2: 2388.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1297
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3277,
    stopColor: "#00334B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5276,
    stopColor: "#006190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6723,
    stopColor: "#007FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7457,
    stopColor: "#008ACC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1322_38448",
    x1: 7.48265,
    y1: 27.0443,
    x2: 14.2566,
    y2: 28.9636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1297,
    stopColor: "#3A67B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5622,
    stopColor: "#357FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9352,
    stopColor: "#3290C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1322_38448",
    x1: 16.1094,
    y1: 28.3564,
    x2: 23.1155,
    y2: 30.3414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1724,
    stopColor: "#4E5CA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9937,
    stopColor: "#1FC3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_38448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow24);
export default __webpack_public_path__ + "static/media/row-2-4.f156ed7c587c21cb15f7ddf740832122.svg";
export { ForwardRef as ReactComponent };